import { createSignUpContainer } from './container'
import { SignUpUI } from './ui/sign-up'
import { getCurrentMarketConfig } from '../../../services/market-service'
import { SignUpOnlyCorporate } from './ui/sign-up-only-corporate'

const allowOnlyCorporate = getCurrentMarketConfig().registration.allowOnlyCorporate
export const SignUpPage = createSignUpContainer(allowOnlyCorporate ? SignUpOnlyCorporate : SignUpUI)
